import { Logo } from "@/components/Logo";
import { useSectionNav } from "@/lib/scroll";
import { CONTACT, NAV_LINKS } from "@/data/site";

export const Footer = () => {
  const go = useSectionNav();

  return (
    <footer data-testid="footer-section" className="border-t border-white/5 px-5 sm:px-8">
      <div className="max-w-7xl mx-auto py-14 flex flex-col md:flex-row md:items-center justify-between gap-10">
        <button data-testid="footer-logo" onClick={() => go("/")} aria-label="Novo Digital Studio — home">
          <Logo />
        </button>
        <nav className="flex flex-wrap items-center gap-x-8 gap-y-3">
          {NAV_LINKS.map((l) => (
            <button
              key={l.path}
              data-testid={`footer-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.path)}
              className="mono text-[11px] tracking-[0.22em] uppercase text-neutral-400 hover:text-neutral-50 transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <a
          data-testid="footer-email"
          href={`mailto:${CONTACT.email}`}
          className="mono text-[11px] tracking-[0.22em] uppercase text-neutral-400 hover:text-neutral-50 transition-colors duration-300"
        >
          {CONTACT.email}
        </a>
      </div>
      <div className="max-w-7xl mx-auto pb-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 mono text-[11px] tracking-[0.15em] uppercase text-neutral-600">
        <span>© 2026 Novo Digital Studio. All rights reserved.</span>
        <span>Modern Websites. Real Results.</span>
      </div>
    </footer>
  );
};
